/*

Ashraf 11/15/2022 3031689933 resetting lock account status
Ashraf 12/27/2022 3031689933 changed the columns for text fields.
Suresh Peddavoora  02/09/2023 3031689933 Modified Styles for Account Summary Background
suresh peddavoora 03/06/2023 3031689933 textfields alignments  fixes
Prakash 03/27/2023 3031689933 fixed account summary issue.
Prakash 12/05/2023 3031689933 fixed alignments issue in tab view.
Prakash 12/06/2023 3031689933 add condition for patient summary in account summary
Prakash 12/06/2023 3031689933 fixed field for patient summary in account summary
Suresh Peddavoora 06/12/2023 3031689933 Fixed Sticky Account summary Tabs Enhancements
Suresh Peddavoora 06/13/2023 3031689933 Added View less anchor in account summary

*/

import React, { useEffect, useState, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@mui/material/Typography';
import { resetLockAccountStatus } from '../../../redux/reducers/AccountSummary';
import AccountSummaryCollapse from './AccountSummaryCollapse';
import AccountSummaryExpand from './AccountSummaryExpand';
import AddNote from './Notes/AddNote';
import AddFile from './Files/AddFile';
import formatSsnNumber from '../../../util/SsnFormat';
import Accordion from '@mui/material/Accordion';
import IconButton from '@mui/material/IconButton';
// import GroupIcon from '@material-ui/icons/Group';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import NotesIcon from '@material-ui/icons/Notes';
import { ReactComponent as UploadFileIcon } from '../../../assets/images/upload_file.svg';
import { ReactComponent as CopyFileIcon } from '../../../assets/images/copyfileicon.svg';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import moment from 'moment';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import formatPhoneNumber from '../../../util/PhoneFormat';
import SeeAllFiles from './Files/SeeAllFiles';
import SeeAllNotes from './Notes/SeeAllNotes';
import { fetchAccountSummary } from '../../../redux/reducers/AccountSummary';

const useStyles = makeStyles((theme) => ({
  rootFirst: {
    padding: '0.6675rem',
    paddingBottom: '1.188rem',
    backgroundColor: '#fff',
    boxShadow: 'none !important',
    [theme.breakpoints.down('md')]: {
      paddingBottom: '8px',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      // backgroundColor: "#ffffff",
      padding: 3,
    },
  },
  rootSecond: {
    backgroundColor: '#fff',
    // marginBottom: "10px",
    boxShadow: 'none !important',
    padding: '0.625rem 1rem 0.9rem 1rem',
    // padding: "0.35rem 1.375rem",
    [theme.breakpoints.down('sm')]: {
      padding: '0px 10px 0px 2px',
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        backgroundColor: '#ffffff',
      },
    },
    media: {
      height: 0,
      paddingTop: '56.25%',
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
    avatar: {
      backgroundColor: red[500],
    },
    patientAccount1: {
      backgroundColor: '#CED4DA',
      color: '#000',
      borderRadius: '15px',
      margin: '0 5px 0 18px',

      '& .MuiTypography-body1': {
        fontSize: '12px',
        padding: '2px 10px',
        cursor: 'pointer',
      },
      '& .MuiSvgIcon-root': {
        paddingLeft: '5px',
        fontSize: '25px',
      },
    },
    patientAccount2: {
      backgroundColor: '#FF6347',
      color: '#fff !important',
      borderRadius: '15px',
      marginRight: '5px',
      '& .MuiTypography-body1': {
        fontSize: '12px',
        padding: '2px 10px',
        color: '#fff !important',
        cursor: 'pointer',
      },
      '& .MuiSvgIcon-root': {
        paddingLeft: '5px',
        fontSize: '25px',
      },
    },
    patientAccount3: {
      backgroundColor: '#808080',
      borderRadius: '15px',
      '& .MuiTypography-body1': {
        fontSize: '12px',
        padding: '2px 10px',
        color: '#fff !important',
        cursor: 'pointer',
      },
      '& .MuiSvgIcon-root': {
        paddingLeft: '5px',
        fontSize: '25px',
      },
    },
  },
  accordionBox: {
    width: '100%',
    padding: '6px !important',
  },
  itemStyle: {
    alignItems: 'center',
    height: '100%',
    '@media (max-width: 599px)': {
      display: 'flex',
    },
    '@media (min-width: 1201px)': {
      display: 'flex',
    },
  },
  labelColor: {
    '&&': {
      fontFamily: '"articulat-cf", sans-serif !important',
      color: '#56657E',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '20.02px',
      letterSpacing: '0.32px',
      textAlign: 'left',
    },
  },
  valueColor: {
    '&&': {
      fontFamily: '"articulat-cf", sans-serif !important',
      color: '#3B4149',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 800,
      lineHeight: '20.02px',
      letterSpacing: '0.32px',
    },
  },
  nameValueColor: {
    '&&': {
      fontFamily: '"articulat-cf", sans-serif !important',
      color: '#3B4149',
      fontSize: '20px',
      fontStyle: 'normal',
      lineHeight: '20.02px',
      letterSpacing: '0.4px',
      textAlign: 'left',
    },
  },
  collapseExpandMenu: {
    '& .MuiPaper-root': {
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
      borderRadius: '10px',
      border: '1px solid #AEB5BF',
      width: '200px',
      border: '1px solid #AEB5BF',
      paddingLeft: '4px',
      paddingRight: '4px',
    },
    '& .MuiMenuItem-root': {
      '&:hover': {
        backgroundColor: '#E3F2FFCC',
        borderRadius: '5px',
      },
    },
  },
  collapseExpandItem: {
    color: '##3B4149',
    fontSize: '15px',
    fontWeight: 400,
    lineHeight: '20.7px',
    textAlign: 'left',
    padding: '0px',
  },
  collapseExpandIcon: {
    color: '#1E88E5',
    width: '14px',
    width: '15px',
  },
  divider: {
    '&&': {
      paddingLeft: '10px',
      borderLeft: '1px solid #CFD4DB',
    },
  },
}));
const useModalStyles = makeStyles((theme) => ({
  closeButton: {
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '24px',
    textAlign: 'center',
    cursor: 'pointer',
    color: '#3B4149',
    '&:hover': {
      color: '#3B4149',
    },
  },
  formBox: {
    borderRadius: '5px 0px 0px 0px',
    border: '1px 0px 0px 0px',
    border: '1px solid #D9DDE3',
    boxShadow: '0px 5px 15px 0px #0000001A',
    overflow: 'hidden',
    '& .MuiDialog-paper': {
      width: '40%',
      maxWidth: 'none',
      '@media (max-width: 699px)': {
        width: '100%',
      },
      '@media (min-width: 700px) and (max-width: 1200px)': {
        width: '60%',
      },
    },
  },
  tableBox: {
    borderRadius: '5px 0px 0px 0px',
    border: '1px 0px 0px 0px',
    border: '1px solid #D9DDE3',
    boxShadow: '0px 5px 15px 0px #0000001A',
    overflow: 'hidden',
    '& .MuiDialog-paper': {
      width: '60%',
      maxWidth: 'none',
      '@media (max-width: 699px)': {
        width: '100%',
      },
      '@media (min-width: 700px) and (max-width: 1200px)': {
        width: '80%',
      },
    },
  },
  boxContent: {
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: 'calc(100vh - 64px)',
  },
}));

const options = [
  { key: 'none', value: 'Select RP Phone Type' },
  { key: '', value: 'Nothing' },
  { key: 'B', value: 'Bad Number' },
  { key: 'C', value: 'Cell Phone' },
  { key: 'G', value: 'Good number' },
  { key: 'H', value: 'On Hold' },
  { key: 'z', value: 'Non-published' },
  { key: 'N', value: 'Non-published' },
  { key: 'U', value: 'Unlisted' },
  { key: '!', value: 'Never Call' },
  { key: 'P', value: 'Privacy Manager' },
  { key: '@', value: 'Cell Manual Consent' },
];

const phoneTypeHandler = (optionKey) => {
  if (optionKey && options.length > 0) {
    const re = options.filter((option) => option.key === optionKey);
    return re.length > 0 ? `${re[0].key} - ${re[0].value}` : '';
  }
};

export default function PatientSummary({ accountNo, age, setAge, hideSummary }) {
  const classes = useStyles();
  const modalClasses = useModalStyles();
  const dispatch = useDispatch();
  const [iconExpanded, setIconExpanded] = useState(true);

  const toggleIcon = () => {
    setIconExpanded(!iconExpanded);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [modalType, setModalType] = useState('');
  const [refreshNotes, setRefreshNotes] = useState(0);

  const importFileForm = (newFile) => {
    if (newFile) {
      setModalType('form');
      handleOpenModal(
        <AddFile
          handleCloseModal={handleCloseModal}
          accountId={initialValues.account}
          fileLoaded={newFile}
        />,
      );
    }
  };

  const handleOpenModal = (content) => {
    setModalContent(content);
    setModalOpen(true);
  };

  const handleCloseModal = (action) => {
    setModalOpen(false);
    handleClose();
    if (action == 'addNotes') {
      handleNote('add');
    } else if (action == 'addFile') {
      handleFile('add');
    } else {
      setRefreshNotes((prevNotes) => prevNotes + 1);
    }
  };

  const handleNote = (action) => {
    if (action === 'add') {
      setModalType('form');
      handleOpenModal(
        <AddNote handleCloseModal={handleCloseModal} accountId={initialValues.account} />,
      );
    } else if (action === 'seeAll') {
      setModalType('table');
      handleOpenModal(
        <SeeAllNotes handleCloseModal={handleCloseModal} accountId={initialValues.account} />,
      );
    }
    handleClose();
  };

  const handleFile = (action) => {
    if (action === 'add') {
      setModalType('form');
      handleOpenModal(
        <AddFile handleCloseModal={handleCloseModal} accountId={initialValues.account} />,
      );
    } else if (action === 'seeAll') {
      setModalType('table');
      handleOpenModal(
        <SeeAllFiles handleCloseModal={handleCloseModal} accountId={initialValues.account} />,
      );
    }
    handleClose();
  };

  const { accountSummaryData, lockedAccountStatus } = useSelector(
    ({ accountSummary }) => accountSummary,
  );

  useEffect(() => {
    setTimeout(() => {
      dispatch(resetLockAccountStatus());
    }, 7000);
    setIconExpanded(true);
  }, [lockedAccountStatus]);

  const convertToGMT = (date) => {
    return moment(date).utc().format('MM/DD/YYYY');
  };

  const getInitialValues = (accountData) => {
    if (Object.keys(accountData).length > 0) {
      return {
        listDate:
          accountSummaryData && accountSummaryData.listDate
            ? convertToGMT(accountSummaryData.listDate)
            : null,
        account:
          accountSummaryData && accountSummaryData.accountNumber
            ? accountSummaryData.accountNumber
            : '',
        seed:
          accountSummaryData && accountSummaryData.seedAccountNumber
            ? accountSummaryData.seedAccountNumber
            : '',
        collector:
          accountSummaryData && accountSummaryData.collectorId
            ? accountSummaryData.collectorId
            : '',
        firstName:
          accountSummaryData && accountSummaryData.firstName ? accountSummaryData.firstName : '',
        lastName:
          accountSummaryData && accountSummaryData.lastName ? accountSummaryData.lastName : '',
        clientNumber:
          accountSummaryData && accountSummaryData.clientNumber
            ? accountSummaryData.clientNumber
            : '',
        clientName:
          accountSummaryData && accountSummaryData.clientName
            ? accountSummaryData.clientName.split(accountSummaryData.clientNumber + ' - ')
            : '',
        clientaccount:
          accountSummaryData && accountSummaryData.referenceNumber
            ? accountSummaryData.referenceNumber
            : '',
        listBalance:
          accountSummaryData &&
          ![null, '', ' ', undefined]?.includes(accountSummaryData?.initialBalance)
            ? new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
            }).format(accountSummaryData.initialBalance)
            : '',
        balance:
          accountSummaryData &&
          ![null, '', ' ', undefined]?.includes(accountSummaryData?.accountBalance)
            ? new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
            }).format(accountSummaryData.accountBalance)
            : '',
        ssn:
          accountSummaryData && accountSummaryData.ssn
            ? formatSsnNumber(accountSummaryData.ssn)
            : '',
        phone:
          accountSummaryData && accountSummaryData.patientPhoneNumber
            ? formatPhoneNumber(accountSummaryData.patientPhoneNumber)
            : '',
        rpfirstName:
          accountSummaryData && accountSummaryData.rpfirstName
            ? accountSummaryData.rpfirstName
            : '',
        rplastName:
          accountSummaryData && accountSummaryData.rplastName ? accountSummaryData.rplastName : '',
        rpphone:
          accountSummaryData && accountSummaryData.rpPhoneNumber
            ? formatPhoneNumber(accountSummaryData.rpPhoneNumber)
            : '',
        patientphoneType:
          accountSummaryData && accountSummaryData.patientBadPhoneFlag
            ? phoneTypeHandler(accountSummaryData.patientBadPhoneFlag)
            : '',
        rpphoneType:
          accountSummaryData && accountSummaryData.rpBadPhoneFlag
            ? phoneTypeHandler(accountSummaryData.rpBadPhoneFlag)
            : '',
        rpssn:
          accountSummaryData && accountSummaryData.rpssn
            ? formatSsnNumber(accountSummaryData.rpssn)
            : '',
        agencyCode:
          accountSummaryData && accountSummaryData.agencyTotalAccounts
            ? accountSummaryData.agencyTotalAccounts
            : '',
        agency:
          accountSummaryData && accountSummaryData.agencyBalance
            ? new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
            }).format(accountSummaryData.agencyBalance)
            : '',
        routeCode:
          accountSummaryData && accountSummaryData.routeTotalAccounts
            ? accountSummaryData.routeTotalAccounts
            : '',
        route:
          accountSummaryData && accountSummaryData.routeBalance
            ? new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
            }).format(accountSummaryData.routeBalance)
            : '',
        dischargeDate:
          accountSummaryData && accountSummaryData.dischargeDate
            ? accountSummaryData.dischargeDate
            : null,
        birthdate:
          accountSummaryData && accountSummaryData.birthDate
            ? convertToGMT(accountSummaryData.birthDate)
            : null,
        serviceDate:
          accountSummaryData && accountSummaryData?.serviceDate
            ? convertToGMT(accountSummaryData?.serviceDate)
            : null,
        admitDate:
          accountSummaryData && accountSummaryData.admitDate ? accountSummaryData.admitDate : null,
        mrnNum: accountSummaryData && accountSummaryData.mrnNum ? accountSummaryData.mrnNum : '',
        daysInAgency:
          accountSummaryData && accountSummaryData.daysInAgency?.toString()
            ? accountSummaryData.daysInAgency
            : '',
        startEndDate:
          accountSummaryData && accountSummaryData.ipStartDate
            ? convertToGMT(accountSummaryData.ipStartDate) +
              ' - ' +
              convertToGMT(accountSummaryData.ipEndDate)
            : null,
        accountMessage:
          accountSummaryData && accountSummaryData.accountMessages
            ? accountSummaryData.accountMessages
            : ['CONFIRM B4 MOVING.', 'VALIDATE 712!!', 'Too early to call.'],
        accountNotes: 0,
        placementDate:
          accountSummaryData && accountSummaryData.listDate
            ? convertToGMT(accountSummaryData.listDate)
            : null,
      };
    }
    return {};
  };

  const [initialValues, setInitialValues] = useState({});

  const memoizedInitialValues = useMemo(
    () => getInitialValues(accountSummaryData),
    [accountSummaryData],
  );

  useEffect(() => {
    setInitialValues(memoizedInitialValues);
  }, [memoizedInitialValues]);

  useEffect(() => {
    dispatch(fetchAccountSummary(accountNo));
  }, [accountNo, dispatch]);

  return (
    <div className={classes.accordionBox}>
      <div className="`row` ">
        <Accordion expanded={true}>
          <AccordionSummary
            expandIcon={
              <>
                <IconButton onClick={toggleIcon}>
                  {iconExpanded ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                </IconButton>
                <IconButton
                  aria-label="more"
                  aria-controls="summary-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreVertIcon />
                </IconButton>
                <Menu
                  id="summary-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={open}
                  onClose={handleClose}
                  className={classes.collapseExpandMenu}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                >
                  <MenuItem
                    className={classes.collapseExpandItem}
                    handleCloseModal={handleCloseModal}
                    onClick={() => handleNote('add')}
                  >
                    <NotesIcon className={classes.collapseExpandIcon} />
                    &nbsp;&nbsp;Add Note
                  </MenuItem>
                  <MenuItem
                    className={classes.collapseExpandItem}
                    handleCloseModal={handleCloseModal}
                    onClick={() => handleFile('add')}
                  >
                    <UploadFileIcon className={classes.collapseExpandIcon} />
                    &nbsp;&nbsp;Upload Doc
                  </MenuItem>
                  <Divider
                    orientation="horizontal"
                    sx={{ borderBottom: '1px solid #CFD4DB' }}
                    flexItem
                  />
                  <MenuItem className={classes.collapseExpandItem}>
                    <CopyFileIcon className={classes.collapseExpandIcon} />
                    &nbsp;&nbsp;Clone
                  </MenuItem>
                </Menu>
              </>
            }
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{
              borderBottom: '1px solid #CFD4DB',
              marginBottom: '0px',
            }}
          >
            <Box
              sx={{ width: '100%', overflow: 'hidden', display: 'flex', justifyContent: 'center' }}
            >
              <Grid container sx={{ width: '100%' }}>
                <Grid item xs={12} sm={12} md={12} lg={2} xl={2} sx={classes.itemStyle}>
                  <Typography
                    className={classes.nameValueColor}
                    sx={{
                      fontWeight: '700 !important',
                    }}
                  >
                    {initialValues.firstName} {initialValues.lastName}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={3} md={2} lg={2} xl={2} className={classes.divider}>
                  <Box alignItems="center" className={classes.itemStyle}>
                    <Typography className={classes.labelColor}>SSN:&nbsp;</Typography>
                    <Typography className={classes.valueColor}>{initialValues.ssn}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={3} md={3} lg={3} xl={3} className={classes.divider}>
                  <Box alignItems="center" className={classes.itemStyle}>
                    <Typography className={classes.labelColor}>DOB:&nbsp;</Typography>
                    <Typography className={classes.valueColor}>
                      {initialValues.birthdate}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={3} md={2} lg={2} xl={2} className={classes.divider}>
                  <Box alignItems="center" className={classes.itemStyle}>
                    <Typography className={classes.labelColor}>Account:&nbsp;</Typography>
                    <Typography className={classes.valueColor}>{initialValues.account}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={3} md={2} lg={2} xl={2} className={classes.divider}>
                  <Box alignItems="center" className={classes.itemStyle}>
                    <Typography className={classes.labelColor} style={{ whiteSpace: 'nowrap' }}>Reference #:&nbsp;</Typography>
                    <Typography className={classes.valueColor}>{initialValues.clientaccount}</Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </AccordionSummary>
          <AccordionDetails sx={{ display: 'block' }}>
            {!iconExpanded ? (
              <AccountSummaryCollapse
                accountSummaryData={initialValues}
                collapse={true}
                handleCloseModal={handleCloseModal}
                handleNote={handleNote}
                handleFile={handleFile}
                refreshNotes={refreshNotes}
                importFileForm={importFileForm}
                handleClick={toggleIcon}
              />
            ) : (
              <AccountSummaryExpand
                accountSummaryData={initialValues}
                handleCloseModal={handleCloseModal}
                handleNote={handleNote}
                handleFile={handleFile}
                refreshNotes={refreshNotes}
                importFileForm={importFileForm}
                handleClick={toggleIcon}
              />
            )}
          </AccordionDetails>
        </Accordion>
      </div>
      <Dialog
        open={modalOpen}
        className={modalType === 'table' ? modalClasses.tableBox : modalClasses.formBox}
        onClose={() => setModalOpen(false)}
      >
        <DialogActions>
          <HighlightOffIcon className={modalClasses.closeButton} onClick={handleCloseModal} />
        </DialogActions>
        <DialogContent className={modalClasses.boxContent}>{modalContent}</DialogContent>
      </Dialog>
    </div>
  );
}
